// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"_m-z","badgeLink":"an-z","category":"bn-z"};